/**
 * AnnouncementAudienceService
 * Service for managing announcement audiences
 */
import { CrudService } from '../base/CrudService';
/**
 * Service for announcement audience CRUD operations
 */
export class AnnouncementAudienceService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? AnnouncementAudienceService.DEFAULT_SERVICE_PATH,
            basePath: AnnouncementAudienceService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
}
AnnouncementAudienceService.DEFAULT_SERVICE_PATH = 'announcements';
AnnouncementAudienceService.BASE_PATH = 'api/announcement-audiences';
//# sourceMappingURL=AnnouncementAudienceService.js.map